import type { Advertisement } from "../api/types";

export const calcImpressionChange = (data: Advertisement) => ({
  readsCount: data.reads_count - data.start_reads_count,
  chatRoomsCount: data.chat_rooms_count - data.start_chat_rooms_count,
  watchesCount: data.watches_count - data.start_watches_count,
});
